import React, { useState } from 'react'
import { CompanyBalanceData } from '../../../../../services/api/companies'
import { View } from './View'

type Props = {
  companyId: string
  balance: CompanyBalanceData
  onBalanceUpdate: () => void
}

export const Container: React.FunctionComponent<Props> = ({
  companyId,
  balance,
  onBalanceUpdate,
}) => {
  const [isFormVisible, setIsFormVisible] = useState<boolean>(false)

  const onBalanceAdjust = () => {
    onBalanceUpdate()
    setIsFormVisible(false)
  }

  return (
    <View
      companyId={companyId}
      balance={balance}
      isFormVisible={isFormVisible}
      setIsFormVisible={setIsFormVisible}
      onBalanceAdjust={onBalanceAdjust}
    />
  )
}
